import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { LogIn, Loader2 } from "lucide-react";
import { useAuth } from "../../lib/auth";
import { useLang } from "../../lib/i18n";

export default function AdminLogin() {
  const nav = useNavigate();
  const { login, user } = useAuth();
  const { t } = useLang();
  const [form, setForm] = useState({ username: "", password: "" });
  const [busy, setBusy] = useState(false);

  React.useEffect(() => {
    if (user) nav("/admin/dashboard", { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(form.username, form.password);
      toast.success("Hoş geldin " + form.username);
      nav("/admin/dashboard", { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#08080D] grid-backdrop flex items-center justify-center px-6">
      <div className="w-full max-w-md relative">
        <div className="absolute -inset-6 rounded-3xl bg-[#A855F7]/10 blur-3xl -z-10" />
        <div className="rounded-3xl border border-white/10 bg-[#101018]/90 p-10 backdrop-blur-xl">
          <div className="flex items-center gap-2 mb-2">
            <span className="w-2 h-2 rounded-full bg-[#A855F7] shadow-[0_0_16px_rgba(168,85,247,0.9)]" />
            <span className="font-mono-ui text-[10px] tracking-[0.3em] text-[#A855F7] uppercase">Ixirli · Studio</span>
          </div>
          <h1 className="font-display text-3xl uppercase tracking-tighter text-white">{t("admin_login")}</h1>

          <form onSubmit={submit} className="mt-8 space-y-5">
            <label className="block">
              <span className="text-[10px] tracking-widest uppercase text-white/40 font-mono-ui">{t("admin_username")}</span>
              <input
                data-testid="login-username"
                type="text"
                autoFocus
                value={form.username}
                onChange={(e) => setForm({ ...form, username: e.target.value })}
                className="mt-1 w-full bg-transparent border-b border-white/20 py-3 text-white focus:outline-none focus:border-[#A855F7] transition-colors"
                required
              />
            </label>
            <label className="block">
              <span className="text-[10px] tracking-widest uppercase text-white/40 font-mono-ui">{t("admin_password")}</span>
              <input
                data-testid="login-password"
                type="password"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                className="mt-1 w-full bg-transparent border-b border-white/20 py-3 text-white focus:outline-none focus:border-[#A855F7] transition-colors"
                required
              />
            </label>
            <button data-testid="login-submit" disabled={busy} className="btn-primary w-full justify-center disabled:opacity-60">
              {busy ? <Loader2 size={16} className="animate-spin" /> : <LogIn size={16} />}
              {t("admin_signin")}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
